import Select from "react-select";
/* import { GetSubEntryMasterdata } from "../../store/subscriptionAtom"; */
import { useContext, useEffect, useState, useRef } from "react";
import { subscriptionService } from "../../services/subscription.service";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import GiftBeneficiaryForm from "./GiftBeneficiaryForm";
import LogicContext from "../../Context/LogicContext";
import { IoMdClose } from "react-icons/io";

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#f9fafb", // Tailwind: bg-gray-50
    borderColor: state.isFocused ? "#0000FF" : "#d1d5db", // gray-400 or gray-300
    boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none", // subtle gray ring
    // "&:hover": {
    //   borderColor: "#9ca3af", // gray-400
    // },
    height: 42,
    // border: 4,
    borderRadius: 6, // rounded-md
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 14,
    width: "100%",
    transition: "all 0.2s ease-in-out",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af", // gray-400
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827", // gray-900
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "#6b7280" : "#9ca3af", // gray-500/gray-400
    "&:hover": {
      color: "#6b7280", // gray-500
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#ffffff", // white dropdown
    borderRadius: 6,
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.05)",
    marginTop: 4,
    fontSize: 14,
    boxShadow: "0 0 0 1px #d1d5db",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FFFFFF" // gray-200
      : state.isFocused
        ? "#f3f4f6" // gray-100
        : "#ffffff", // white
    color: "#111827", // gray-900
    padding: "8px 12px",
    cursor: "pointer",
    borderColor: state.isFocused ? "#9ca3af" : "#d1d5db", // gray-400 or gray-300
    "&:hover": {
      backgroundColor: "#f3f4f6", // gray-400
    },
    border: "2px",
    transition: "background-color 0.2s ease",
  }),
};

function GiftBeneficiary(props) {
  const [dataList, setDataList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const logicContext = useContext(LogicContext);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    if (!dataList?.length && props?.Customer_Id) {
      loadBeneficiaryList(props?.Customer_Id);
    }

    if (!props?.Customer_Id) {
      logicContext.showToast(
        `You need to select a Customer before beneficiary list`,
        "error"
      );
    }

    return () => {
      isMounted.current = false;
    };
  }, [props.isAGift]);

  const loadBeneficiaryList = (id) => {
    subscriptionService.beneficiaryList(id).then((res) => {
      if (isMounted.current) {
        if (res?.data?.length) {
          setDataList(res.data);
        }
      }
    });
  };

  const onSelectBeneficiary = (beneficiary) => {
    props.onGiftPersonSelect(beneficiary);
  };

  const processNewGiftPerson = (form) => {
    subscriptionService
      .createNewBeneficiary({ ...form, Customer_Id: props?.Customer_Id })
      .then((res) => {
        if (res?.data !== undefined) {
          const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
          const { message_id, message_text } = cleanResponse;

          if (message_id == 1) {
            logicContext.showToast(message_text, 'success');
            loadBeneficiaryList(props?.Customer_Id);
            setOpenForm(false);
          }
        }

      });
  };

  return (
    <>
      <Select
        styles={customStyles}
        onChange={onSelectBeneficiary}
        defaultValue={props?.defaultVal}
        options={dataList?.map((giftPerson) => {
          return {
            ...giftPerson,
            label: `${giftPerson?.Recipient_Full_Name} ${giftPerson?.Recipient_Phone_Number}`,
          };
        })}
      />
      <br />
      <div className="col-span-6 mt-2">
        <button
          onClick={() => setOpenForm(true)}
          type="button"
          class="bg-white hover:bg-gray-100 text-[#486EF8]  font-semibold py-2 px-4 border-[1.5px] border-[#486EF8] hover:ring-1 hover:ring-offset-1 hover:ring-[#486EF8]/80 rounded-md focus:outline-none transition-all duration-500"
        >
          New Beneficiary
        </button>
      </div>
      {/* Modal Select */}
      <>
        {/* <Modal
          open={openForm}
          onClose={() => setOpenForm(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="absolute top-1/2 inset-x-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-[600px] bg-white overflow-hidden shadow-md rounded-xl">
            <div class="bg-white flex items-center justify-end pt-2 px-3 z-40">
              <button
                onClick={() => setOpenForm(false)}
                className="w-fit p-1 rounded-full hover:bg-gray-200 active:bg-gray-100 focus:outline-none"
                aria-label="Close"
              >
                <IoMdClose className="h-[20px] w-[20px] text-gray-600" />
              </button>
            </div>
            <div className="max-w mx-auto bg-white rounded-lg pt-4 pb-10 px-6 h-full max-h-[calc(100vh-100px)] overflow-y-auto">
              <GiftBeneficiaryForm
                setOpenForm={setOpenForm}
                processNewGiftPerson={(form) => processNewGiftPerson(form)}
              />
            </div>
          </div>
        </Modal> */}

        <Modal
          open={openForm}
          onClose={() => setOpenForm(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div className="relative w-full max-w-[600px] bg-white rounded-xl shadow-2xl overflow-hidden max-h-[calc(100vh-80px)] flex flex-col">
              {/* Close Button */}
              <div className="flex justify-end py-2 px-3 border-b border-gray-100 bg-white">
                <button
                  onClick={() => setOpenForm(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition active:bg-gray-200 focus:outline-none"
                  aria-label="Close"
                >
                  <IoMdClose className="h-[20px] w-[20px] text-gray-500" />
                </button>
              </div>

              {/* Content Area */}
              <div className="overflow-y-auto px-6 py-6">
                <GiftBeneficiaryForm
                  setOpenForm={setOpenForm}
                  processNewGiftPerson={(form) => processNewGiftPerson(form)}
                />
              </div>
            </div>
          </div>
        </Modal>
      </>
    </>
  );
}

export default GiftBeneficiary;
